module.exports = __webpack_public_path__ + "static/media/icon_arrow_g4r.b08a67e8.svg";